var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "page-list-page" } }, [
    _c("h3", { staticClass: "title" }, [
      _vm._v(_vm._s(_vm.$t("message.metaLeadPages"))),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "toolbar" }, [
      _c("div"),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "SupsisButton",
            {
              attrs: { ghost: "", primary: "", disabled: _vm.syncing },
              on: { click: _vm.syncPages },
            },
            [
              _c(
                "i",
                {
                  staticClass: "material-icons",
                  class: { spinning: _vm.syncing },
                },
                [_vm._v("sync")]
              ),
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("message.syncPages")) +
                  "\n            "
              ),
            ]
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-wrapper" },
      [
        _c("SupsisTable", {
          attrs: {
            columns: _vm.getCols(),
            rows: _vm.pages,
            "empty-data-bordered": "",
            options: {
              rowStyleOption: _vm.rowStyleOption,
              fixedHeader: true,
              id: "pages-table",
              borderX: true,
              borderY: true,
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }